import { _ as _objectSpread2 } from '../../../dist/objectSpread2-811c5212.esm.js';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { createContext, createElement } from 'react';
import { ConditionalWrapper } from '../../../conditional-wrapper/dist/uswitch-ev-utils-conditional-wrapper.esm.js';
import { isObject } from '../../../obj/dist/uswitch-ev-utils-obj.esm.js';
import { ExperienceProvider } from 'react-chansey';
import 'react-chansey/lib/provider';
import { isDev } from '../../../helpers/env/dist/uswitch-ev-utils-helpers-env.esm.js';
import { jsx } from 'theme-ui/jsx-runtime';
import '@babel/runtime/helpers/slicedToArray';
import '@babel/runtime/helpers/defineProperty';
import '@babel/runtime/helpers/typeof';
import '../../../nil/dist/uswitch-ev-utils-nil.esm.js';

var _excluded = ["category", "label", "value"];
var SlimlineContext = /*#__PURE__*/createContext([]);
var SlimlineExtractor = function SlimlineExtractor(_ref) {
  var extractor = _ref.extractor,
    children = _ref.children;
  return jsx(SlimlineContext.Provider, {
    value: extractor,
    children: children
  });
};

/**
 * Map for the components that eevee should include
 */
var EVCComponentContext = /*#__PURE__*/createContext({});
var EVCComponentProvider = EVCComponentContext.Provider;

/**
 * Provider for the contentful options
 */
var EVCOptionsContext = /*#__PURE__*/createContext(function () {
  return {};
});
var EVCOptionsProvider = EVCOptionsContext.Provider;

/**
 * Provider for the data set that eevee uses
 */
var EVCDataContext = /*#__PURE__*/createContext({});
var EVCDataProvider = EVCDataContext.Provider;

/**
 * Experience provider for audience & testing toggles
 */
var EVExperienceProvider = ExperienceProvider;
var EVTrackingContext = /*#__PURE__*/createContext({});
var EVTrackingProvider = function EVTrackingProvider(_ref2) {
  var children = _ref2.children,
    config = _ref2.value;
  var track = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action, _ref3, isTwinEvent) {
      var category, label, value, props, properties, _config$client, args;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              category = _ref3.category, label = _ref3.label, value = _ref3.value, props = _objectWithoutProperties(_ref3, _excluded);
              properties = _objectSpread2({
                category: category,
                label: label,
                value: value
              }, props);
              if (!isTwinEvent) {
                _context.next = 12;
                break;
              }
              args = [[action, properties], ["".concat(config.twinEventPrefix, " ").concat(action), properties]];
              if (isDev) {
                console.log('[TRACKING] trackAll:', args);
                window.trackings = window.trackings || {};
                window.trackings.trackAll = window.trackings.trackAll || [];
                window.trackings.trackAll.push(args);
              }
              if (!(config !== null && config !== void 0 && (_config$client = config.client) !== null && _config$client !== void 0 && _config$client.trackAll)) {
                _context.next = 9;
                break;
              }
              return _context.abrupt("return", config.client.trackAll(args));
            case 9:
              if (isDev) {
                console.log('[TRACKING] trackAll not set');
              }
            case 10:
              _context.next = 13;
              break;
            case 12:
              return _context.abrupt("return", new Promise(function (resolve) {
                var _config$client2;
                var args = [action, properties, resolve];
                if (isDev) {
                  console.log('[TRACKING] track:', args);
                  window.trackings = window.trackings || {};
                  window.trackings.track = window.trackings.track || [];
                  window.trackings.track.push(args);
                  resolve();
                }
                if (config !== null && config !== void 0 && (_config$client2 = config.client) !== null && _config$client2 !== void 0 && _config$client2.track) {
                  var _config$client3;
                  return (_config$client3 = config.client).track.apply(_config$client3, args);
                } else if (isDev) {
                  console.log('[TRACKING] track not set');
                }
              }));
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function track(_x, _x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/createElement(EVTrackingContext.Provider, {
    value: {
      track: track,
      client: config.client
    }
  }, children);
};

/**
 * Core provider for all three things
 *
 * @param {Object} props - The component properies.
 * @param {Object} props.components - A map of components to see https://github.com/uswitch/recharge-eevee/tree/master/packages/ev-components/src/components/defaults/components.jsx
 * @param {Function} props.options - Function to retrieve a list of contentful Rich Text options see https://github.com/uswitch/recharge-eevee/tree/master/packages/ev-components/src/components/defaults/options.jsx
 * @param {Object} props.data - Your main contentful data see //TODO: Write schema for data strucuture
 * @param {Object} [props.experiences] - A list of experiences
 * @param {any} props.children - The Main body of your application
 *
 * @returns {*} Your app
 */
var EVCoreProvider = function EVCoreProvider(_ref5) {
  var components = _ref5.components,
    options = _ref5.options,
    data = _ref5.data,
    experiences = _ref5.experiences,
    tracking = _ref5.tracking,
    children = _ref5.children;
  return jsx(EVCDataProvider, {
    value: data,
    children: jsx(EVCComponentProvider, {
      value: components,
      children: jsx(EVCOptionsProvider, {
        value: options,
        children: jsx(ConditionalWrapper, {
          condition: Boolean(tracking),
          wrapper: EVTrackingProvider,
          value: tracking,
          children: jsx(ConditionalWrapper, {
            condition: isObject(experiences),
            wrapper: EVExperienceProvider,
            value: experiences,
            children: children
          })
        })
      })
    })
  });
};

export { EVCComponentContext, EVCComponentProvider, EVCDataContext, EVCDataProvider, EVCOptionsContext, EVCOptionsProvider, EVCoreProvider, EVExperienceProvider, EVTrackingContext, EVTrackingProvider, SlimlineContext, SlimlineExtractor, EVCoreProvider as default };
